
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ShuffleMaps/Meetups",
      function () {
        return require("private-next-pages/ShuffleMaps/Meetups.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ShuffleMaps/Meetups"])
      });
    }
  